module.exports = {"welcome":"Welkom!"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/general.json
// module id = RYyu
// module chunks = 11